import { makeRunColumnAction } from '../../common-actions/run-column.action';
import { ToolCallModel } from '../tool-call.model';
import { ToolCallColumnSnapshotAction } from './tool-call-column-snapshot.action';
import { ToolCallRunFromStartAction } from './run-from-start.action';

export class ToolCallRunColumnAction extends makeRunColumnAction(
  'Run Tool Call Column',
  ToolCallModel,
  ToolCallRunFromStartAction,
  ToolCallColumnSnapshotAction
) {}
